import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getCampgroundAmenities } from '@/redux/selectors/listing/amenities';

import Amenities from './Amenities';

interface ICampgroundAmenitiesContainerProps {
  isEscapes?: boolean;
  isCentered?: boolean;
}
const CampgroundAmenitiesContainer = ({
  isEscapes = false,
  isCentered = false,
}: ICampgroundAmenitiesContainerProps) => {
  const intl = useIntl();

  const amenities = useSelector(getCampgroundAmenities);
  const availableAmenities = amenities.list.filter(amenity => amenity.available);

  const title = isEscapes
    ? intl.formatMessage({
        defaultMessage: 'Complimentary Amenities',
        id: 'kf4Zg5',
      })
    : intl.formatMessage({
        defaultMessage: 'Amenities',
        id: 'e38GOF',
      });

  return (
    <>
      {isEscapes && (
        <Heading
          variant={EHeadingStyleVariant.H4}
          className={cn('font-normal', { 'md:text-center': isCentered })}
          component="h2">
          {title}
        </Heading>
      )}
      <Amenities
        items={amenities.list}
        categories={amenities.categories}
        modalTitle={title}
        isEscapes={isEscapes}
        isCentered={isCentered}
        showMoreText={intl.formatMessage(
          { defaultMessage: 'Show all {detailCount} features', id: '5acq69' },
          { detailCount: availableAmenities.length },
        )}
      />
    </>
  );
};

export default CampgroundAmenitiesContainer;
